/* eslint-disable react/forbid-component-props */
import React from 'react';
import { Page, Text, View, Document, Font, Image } from '@react-pdf/renderer';
import Borna from '../../assets/fonts/Borna/Borna-Regular.otf';
import BornaMedium from '../../assets/fonts/Borna/Borna-Medium.otf';
import BornaSemiBold from '../../assets/fonts/Borna/Borna-SemiBold.otf';
import styles, { pxToMm } from './styles';
import leftImage from './image/leftImage.png';
import klettGruppeLogo from './image/klettGruppeLogo.png';
import signature from './image/signature.png';
import muLogo from './image/muLogo.png';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

Font.register({
  family: 'Borna',
  fonts: [
    {
      src: Borna,
    },
    {
      src: BornaMedium,
      fontWeight: 500,
    },
    {
      src: BornaSemiBold,
      fontWeight: 600,
    },
  ],
});

interface Props {
  userName: string;
  title: string;
  duration: number
  theme: string[]
  certifiedAt: number
}

const CourseCertificate: React.FC<Props> = (props) => {
  const { title, userName, duration, theme, certifiedAt } = props;
  const { t } = useTranslation();
  const certifiedDate = moment(certifiedAt).format('DD.MM.YYYY');

  return (
    <Document>
      <Page size='A4' style={styles.page} orientation='portrait'>
        <View style={styles.imageContainer}>
          <Image src={leftImage} style={styles.image} />
        </View>
        <View style={styles.container}>
          <View style={styles.main}>
            <Text style={styles.header}>
              {t('Certificate - Further training for teachers')}
            </Text>
            <Text style={styles.userName}>{userName}</Text>
            <Text style={{ ...styles.text, paddingBottom: pxToMm(30) }}>
              {t('You have completed the online training')}
            </Text>
            <Text style={styles.courseTitle}>{title}</Text>
            <Text style={{ ...styles.text, paddingBottom: pxToMm(120) }}>
              {t('successfully completed.')}
            </Text>
            <Text style={styles.text}>
              {t(
                'In the {{duration}}-minute online training course, you were taught content from the {{theme}}.',
                { duration, theme: theme.join(', ') }
              )}
            </Text>
          </View>
          <View style={styles.footer}>
            <View style={styles.footerDetails}>
              <Text style={styles.certifiedAtText}>
                Berlin, {certifiedDate}
              </Text>
              <View style={styles.signatureContainer}>
                <Image style={styles.signatureImage} src={signature} />
                <View style={styles.withSeparator}>
                  <Text style={styles.signatureText}>Maximilian Daub</Text>
                  <Text style={styles.signatureText}>{t('Management')} meinUnterricht</Text>
                </View>
              </View>
            </View>
            <View style={styles.footerTextContainer}>
              <Image src={klettGruppeLogo} style={styles.klettLogo} />
              <View>
                <Text style={styles.footerText}>
                  <Text style={{ fontWeight: 500 }}>meinUnterricht </Text>
                  {t('is a')}
                </Text>
                <Text style={styles.footerText}>{t('Companies of the Klett Group')}</Text>
              </View>
            </View>
            <Image style={styles.logo} src={muLogo} />
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default CourseCertificate;
